import React from 'react'
import NoticeMngTemplate from '../../components/noticemng/NoticeMngTemplate';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const NoticeMngPage = () => {
  return (
    <div>
    <BreadcrumbsContainer title="공통관리/공지사항 관리/공지사항 리스트" icon="notice"/>
    <NoticeMngTemplate/>
  </div>
  )
}

export default NoticeMngPage